<template>
  <div slider :class="type" @click="clicked">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <slot />
      </div>
    </div>
    <div class="swiper-pagination" v-if="pagination"></div>
    <div class="swiper-navigation" v-if="navigation">
      <a class="swiper-button-prev" />
      <a class="swiper-button-next" />
    </div>
  </div>
</template>

<style lang="less">
@import "~@/less/proj";

[slider] {
  .swiper-slide {
    .-box;
  }

  .swiper-pagination {
    .tc;
    .wf;
    .rel;
    .fs(0);
    .mt(40);

    .swiper-pagination-bullet {
      .ib;
      .wh(35, 4);
      .m(0, 5);
      .bgc(#c1c7ce);
      .br(0);
      .pointer;
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      .bgc(@c-blue);
    }
  }
}
</style>

<script>
import _ from 'lodash';
import Swiper from 'swiper';
import { addClass } from '@/utils';

export default {
  name: 'Slider',
  props: {
    pagination: { default: true },
    navigation: { default: false },
    changed: { default: null },
    useThumbs: { type: Boolean, default: false },
    option: Object,
    type: String,
  },
  data() {
    return {
      slider: null,
      intervalID: -1,
      opt: null,
      timer: null,
      changedListener: [],
      sliderMoveListener: [],
    };
  },
  mounted() {
    if (!this.useThumbs) this.init();
  },
  beforeDestroy() {
    if (this.slider) this.slider.destroy();
  },
  methods: {
    init(thumbsSwiper) {
      this.intervalID = setInterval(() => {
        if (_.every(this.$el.querySelectorAll('img'), e => e.complete)) {
          window.clearInterval(this.intervalID);
          this.opt = _.extend({
            loop: true,
          }, this.option);

          if (this.pagination) {
            this.opt.pagination = _.extend({
              el: this.$el.querySelector('.swiper-pagination'),
              clickable: true,
            }, this.opt.pagination);
          }

          if (thumbsSwiper) {
            this.opt.thumbs = { swiper: thumbsSwiper };
          }

          if (!this.opt.on) this.opt.on = {};
          if (this.opt.on.slideChange) this.changedListener.push(this.opt.on.slideChange);
          this.opt.on.slideChange = this.slideChanged;
          if (this.opt.on.sliderMove) this.sliderMoveListener.push(this.opt.on.sliderMove);
          this.opt.on.sliderMove = this.sliderMove;

          if (this.$el.querySelector('.swiper-wrapper > .swiper-slide') === null) {
            _.forEach(this.$el.querySelectorAll('.swiper-wrapper > *'), (e) => {
              addClass(e, 'swiper-slide');
            });
          }

          if (this.$props.navigation) {
            this.opt.navigation = {
              nextEl: this.$el.querySelector('.swiper-button-next'),
              prevEl: this.$el.querySelector('.swiper-button-prev'),
            };
          }

          this.slider = new Swiper(
            this.$el.querySelector('.swiper-container'),
            this.opt,
          );
          this.$emit('initialized', this.slider);
        }
      }, 30);
    },
    beforeDestroy() {
      this.slider.destroy();
    },
    stopAuto() {
      this.slider.autoplay.stop();
    },
    startAuto() {
      this.slider.autoplay.start();
    },
    prev() {
      this.slider.slidePrev();
    },
    next() {
      this.slider.slideNext();
    },
    go(index) {
      this.slider.slideTo(index);
    },
    now() {
      return this.slider ? this.slider.realIndex : 0;
    },
    disable() {
      if (this.slider) {
        this.slider.destroy(true, false);
        this.$el.querySelector('.swiper-wrapper').style.transform = 'none';
      }
    },
    enable() {
      this.slider = new Swiper(
        this.$el.querySelector('.swiper-container'),
        this.opt,
      );
    },
    clicked(e) {
      let t = e.target;
      while (t) {
        if (t === this.$el) break;
        if (t.getAttribute('data-click')) {
          this.$emit('click', t.getAttribute('data-click'), t);
          break;
        }
        t = t.parentNode;
      }
    },
    slideChanged() {
      if (this.changed) this.changed(this.now());
      _.forEach(this.changedListener, listener => listener(this.now()));
    },
    sliderMove() {
      _.forEach(this.sliderMoveListener, listener => listener(this.now()));
    },
    setTimer(timer) {
      this.changedListener.push(timer.changed);
      this.sliderMoveListener.push(timer.sliderMove);
    },
  },
};

</script>
